import {
  CohortModel,
  FetchAllUsers,
  FetchCohorts,
  MemberData,
} from "@mikros/library";
import {
  Box,
  Button,
  Checkbox,
  Pagination,
  PaginationItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import React, {
  JSXElementConstructor,
  ReactElement,
  ReactNode,
  ReactPortal,
  useEffect,
  useState,
} from "react";
import { FormattedMessage, useIntl } from "react-intl";
import ApiServices from "../../../service/apiService";
import Account from "../../../utils/apiConfig";
import ErrorHandler from "../../../utils/errorConfig";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Alert } from "@mikros/shared-ui";
import { useNavigate } from "react-router-dom";

export interface AddNewUserProps {
  userData: FetchAllUsers;
  userDataFunction: Function;
  search: boolean;
  searchFunction: Function;
  totalCount: number;
  totalCountFunction: Function;
  formData: any;
  formDataFunction: Function;
  hasMoreDataReference: any;
  currentCohort: CohortModel;
  cohortListState: Function;
  addNewState: Function;
  addNewUpdate: () => void;
  coh: FetchCohorts;
  delBut: Function;
  refreshedCohorts: () => void;
  selectedLanguageFunction: Function;
  selectedLanguage: any;
  languages: any;
}

export function AddNewUsersDup(props: AddNewUserProps) {
  const theme = createTheme({
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
    },
  });
  const allValue = "All";
  const intl = useIntl();
  const navigate = useNavigate();
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [lastKey, setLastKey] = useState<any>("");
  const [filteredData, setFilteredData] = useState<any>([]);
  const [addAll, setAddAll] = useState<boolean>(false);

  const [selectedUsers, setSelectedUsers] = React.useState<{
    [id: string]: boolean | number[];
  }>({});
  const [newlyAddedUsers, setNewlyAddedUsers] = useState<string[]>([]);
  const [successDialog, setSuccessDialog] = React.useState<boolean>(false);

  const existingCohortList = props?.coh?.cohortUsers?.map(
    (user) => user.userId
  );
  console.log("existing cohort list data", existingCohortList);

  console.log("user fetch model in add new user dup", props.userData);
  console.log("add new user dup file");
  const paginatedData = props.search
    ? rowsPerPage === -1
      ? props?.userData?.users
      : props?.userData?.users?.slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage
        )
    : rowsPerPage === -1
    ? props?.userData?.users
    : props?.userData?.users?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      );
  const totalPages =
    props?.userData.users?.length > 0
      ? Math.ceil(props?.userData?.users?.length / rowsPerPage)
      : 1;

  const selectedKeys = Object.keys(selectedUsers);
  const isIndeterminate =
    selectedKeys?.length > 0 && selectedKeys?.length < paginatedData?.length;
  // const isAllSelected = selectedKeys?.length === paginatedData?.length;

  const isAllSelected =
    paginatedData.length > 0 && // Ensure data exists
    paginatedData.every((row) => selectedUsers[row.userId] === true);

  const toTitleCase = (value: any) => {
    if (typeof value === "string") {
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
    return value ?? ""; // Return the original value if not a string, or "N/A" if null/undefined
  };
  const toggleSuccessDialog = () => {
    setSuccessDialog(!successDialog);
  };

  const handleItemClick = (lang: string) => {
    let updatedSelection = [...props.selectedLanguage];
    if (lang === allValue) {
      updatedSelection = [...props.languages];
    } else {
      if (updatedSelection.includes(lang)) {
        updatedSelection = updatedSelection.filter((l) => l != lang);
      } else {
        updatedSelection.push(lang); //check
      }
    }
    if (updatedSelection.length === props.languages.length) {
      updatedSelection = [...props.languages];
    }
    // setSelectedLanguage(updatedSelection);
    props.selectedLanguageFunction(updatedSelection);
  };

  const addSelected = () => {
    let body: MemberData = {
      //@ts-ignore
      cohortData: {},
      users: [],
    };

    body.users = [];
    body.cohortData.entityId = accountInstance.accntId;
    body.cohortData.recType = "Cohort_" + props?.currentCohort?.cohortId;
    body.cohortData.accntId = accountInstance.accntId;
    body.cohortData.cohortId = props?.currentCohort?.cohortId;
    body.cohortData.cohortName = props?.currentCohort?.cohortName;
    body.cohortData.cohortType = "STATIC";
    body.cohortData.createdAt = 1690218282640;
    body.cohortData.createdBy = "40c60358-adf4-415c-bed3-f542efd4bbc6";
    body.cohortData.date = "2023-07-24T17:04:42Z";
    body.cohortData.description = props?.currentCohort?.description;
    body.cohortData.entryType = "COHORT";
    body.cohortData.status = "ACTIVE";
    body.cohortData.updatedAt = 1690218734168;
    body.cohortData.updatedBy = "2f413330-4cc7-49a8-94f6-6ae2e894260e";

    console.log("initial user body", body);
    const selectedKeys = Object.keys(selectedUsers);
    console.log("Selected key in add new", selectedKeys);

    const EmployeeId = props.coh.cohortUsers.map((id) => id.empId).toString();
    selectedKeys.forEach((key) => {
      if (selectedUsers[key] && !existingCohortList.includes(key)) {
        console.log("if condition", selectedUsers[key]);
        const addUser = {
          userId: key,
          empId: EmployeeId,
        };
        body.users.push(addUser);
      }
    });

    console.log("after assign of user data in add user", body.users);
    console.log("Selected state keys:", Object.keys(selectedUsers));
    body.cohortData.cohortuserCnt = props?.coh?.cohortUsers?.length;
    console.log("updated user data lenght", body?.cohortData?.cohortuserCnt);
    console.log("updated user body", body);
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api
        .makeRequest(
          `${accountInstance.accntId}/cohort/${props.currentCohort.cohortId}/addmember`,
          "PUT",
          body
        )
        .then(async (body) => {
          if (body && body.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(body.errorMessage);
            return;
          }
          console.log("Create form response add working", body);

          toggleSuccessDialog();
        });
    }
  };

  const addEverything = async () => {
    try {
      console.log("Checking if search is active...");

      let body: MemberData = {
        cohortData: {
          entityId: accountInstance.accntId,
          recType: "Cohort_" + props?.currentCohort?.cohortId,
          accntId: accountInstance.accntId,
          cohortId: props?.currentCohort?.cohortId,
          cohortName: props?.currentCohort?.cohortName,
          cohortType: "STATIC",
          createdAt: 1690218282640,
          createdBy: "40c60358-adf4-415c-bed3-f542efd4bbc6",
          date: "2023-07-24T17:04:42Z",
          description: props.currentCohort.description,
          entryType: "COHORT",
          status: "ACTIVE",
          updatedAt: 1690218734168,
          updatedBy: "2f413330-4cc7-49a8-94f6-6ae2e894260e",
          cohortuserCnt: 0, // Will be updated later
        },
        // users:  [], // Use filtered users if search is active
        users: [],
      };

      if (props.search) {
        console.log(
          "Search is active, using filtered users from props.userData..."
        );

        if (Array.isArray(props.userData.users)) {
          console.log("array data");
          body.users = props?.userData?.users?.map((user) => ({
            userId: user?.userId,
            empId: user?.empId,
          }));
        } else {
          console.warn("props.userData is not an array!", props.userData);
          return; // Exit early to prevent errors
        }
      }

      // Ensure correct cohort user count
      body.cohortData.cohortuserCnt = props?.coh?.cohortUsers?.length;

      console.log("Final user body before API request:", body);

      let api = ApiServices.getInstance();
      if (accountInstance.accntId) {
        api
          .makeRequest(
            `${accountInstance.accntId}/cohort/${props?.currentCohort?.cohortId}/addmember`,
            "PUT",
            body
          )
          .then(async (response) => {
            if (response && response.errorMessage) {
              setErrorFlag(true);
              await errorInstance.updateErrorCode(response?.errorMessage);
              return;
            }
            console.log("API Response:", response);
            toggleSuccessDialog();
          });
      }
    } catch (error) {
      console.error("Error in addEverything:", error);
    }
  };

  const handleSelectUser = (userId: string) => {
    // setSelectedUsers((prevSelected) => ({
    //   ...prevSelected,
    //   [userId]: prevSelected[userId] ? false : true,
    // }));

    setSelectedUsers((prevSelected) => ({
      ...prevSelected,
      [userId]: !prevSelected[userId], // Toggle selection (true/false)
    }));
  };
  // const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   if (event.target.checked) {
  //     const newSelected = paginatedData?.reduce((acc, user) => {
  //       acc[user.userId] = true; //select all
  //       return acc;
  //     }, {} as { [id: string]: boolean });
  //     setSelectedUsers(newSelected);
  //   } else {
  //     setSelectedUsers({}); //deseclect all
  //   }
  // };

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSelectedState = event.target.checked;

    setSelectedUsers((prevSelected) => {
      const updatedSelection = { ...prevSelected };

      paginatedData.forEach((row) => {
        updatedSelection[row.userId] = newSelectedState; // Select or unselect all rows
      });

      return updatedSelection;
    });
  };

  const handleChangePage = async (event: any, newPage: number) => {
    setPage(newPage - 1);
    console.log("click of handle change page");

    if (!loading && !props.search) {
      // props.refreshDataReference.current = true; //  Enable data loading on user action

      if (props.hasMoreDataReference.current) {
        fetchUsers(rowsPerPage, lastKey); //  Fetch only if more data exists
      }
    }
  };
  /*const handleRowsPerPageChange = (event: { target: { value: string } }) => {
    props.formDataFunction({
      designation: "", // Reset all fields to empty or their default value
      firstName: "",
      branchName: "",
      location: "",
      department: "",
    });
    const newRowsPerPage = parseInt(event.target.value, 10);
    console.log("Rows per page change value:", newRowsPerPage);

    setRowsPerPage(newRowsPerPage);
    setPage(0); // Reset to first page
    // props.pageFunction(0)

    setLastKey(null); // Reset pagination key
    // setTotalUsers(0)// reset user count
    props.searchFunction(false);
    props.userDataFunction({ users: [] }); // clear previous user data
    props.selectedLanguageFunction([allValue]);
    handleItemClick(allValue);

    fetchUsers(newRowsPerPage, ""); // Use newRowsPerPage directly
  };*/
  const handleRowsPerPageChange = (event: { target: { value: string } }) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    console.log("Rows per page change value", newRowsPerPage);
    setRowsPerPage(newRowsPerPage);
    if (!props.search) {
      props.formDataFunction({
        firstName: "",
        branchName: "",
        department: "",
        location: "",
        designation: "",
        email: "",
        phNo: "",
      });
      setPage(0);
      setLastKey(null);
      props.searchFunction(false);
      props.userDataFunction({ users: [] });
      props.selectedLanguageFunction([allValue]);
      handleItemClick(allValue);
      fetchUsers(newRowsPerPage, "");
    }
  };

  // correct working implementation of fetch users
  function fetchUsers(limit: number, key: string) {
    let api = ApiServices.getInstance();

    if (limit === -1) {
      setLoading(true);
      console.log("inside limit equal -1");
      api
        .makeRequest(`${accountInstance.accntId}/user`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log("entered error code handling in user details");
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          }

          // const filteredUsers = Array.isArray(data?.users)
          //   ? data.users.filter(
          //       (user: any) => !existingCohortList?.includes(user.userId)
          //     )
          //   : [];

          const filteredUsers = Array.isArray(data?.users)
            ? data.users.filter(
                (user: any) =>
                  user.status === "ACTIVE" &&
                  !existingCohortList?.includes(user.userId)
              )
            : [];

          props.userDataFunction({ ...data, users: filteredUsers });
          props.totalCountFunction(filteredUsers?.length);
          setLoading(false);
          props.hasMoreDataReference.current = !!data.lastKey;
        });
      return;
    }

    if (accountInstance.accntId && key === "") {
      setLoading(true);
      console.log("entered when last key is null");
      api
        .makeRequest(`${accountInstance.accntId}/user?limit=20`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log(
              "I entered error code handling in user course analytics when last key is null"
            );
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          }

          const filteredUsers = Array.isArray(data?.users)
            ? data.users.filter(
                (user: any) =>
                  user.status === "ACTIVE" &&
                  !existingCohortList?.includes(user.userId)
              )
            : [];

          console.log("filtered users print", filteredUsers);

          props.userDataFunction({ ...data, users: filteredUsers });
          props.totalCountFunction(filteredUsers?.length);
          setLastKey(data.lastKey);
          props.hasMoreDataReference.current = !!data.lastKey;
          setLoading(false);
        });
    }

    // Handling pagination
    else if (accountInstance.accntId && key !== null) {
      setLoading(true);
      console.log("Fetching next page with lastKey:", key);
      api
        .makeRequest(
          `${accountInstance.accntId}/user?limit=${limit}&lastKey=${key}`,
          "GET"
        )
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log(
              "I entered error code handling in user course analytics when last key is not null"
            );
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          }

          const filteredUsers = Array.isArray(data?.users)
            ? data.users.filter(
                (user: any) =>
                  user.status === "ACTIVE" &&
                  !existingCohortList?.includes(user.userId)
              )
            : [];

          props.userDataFunction((prevData: any) => {
            const existingUsers = Array.isArray(prevData?.users)
              ? prevData.users
              : [];
            return {
              ...prevData,
              users: [...existingUsers, ...filteredUsers],
            };
          });

          props.totalCountFunction(
            (prevCount: any) => prevCount + filteredUsers?.length
          );
          setLastKey(data.lastKey);
          props.hasMoreDataReference.current = !!data.lastKey;
          setLoading(false);
        });
    }
  }

  useEffect(() => {
    console.log("inside use effect where I am fetching data");

    fetchUsers(rowsPerPage, lastKey);
    // }
  }, [accountInstance.accntId]);
  useEffect(() => {
    if (page >= totalPages) {
      setPage(Math.max(totalPages - 1, 0));
    }
  }, [totalPages, page]);
  return (
    <div>
      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              if (errorInstance.permDenied === true) {
                navigate("/home");
              } else {
                navigate("/users");
              }
            }}
          />
        </Dialog>
      )}
      {successDialog && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={intl.formatMessage({
              id: "users.addNewUsers.addMessage",
            })}
            buttonText={intl.formatMessage({ id: "users.buttonText.Ok" })}
            icon={"successShape.png"}
            iconMsg={intl.formatMessage({ id: "iconMsgSuccess" })}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              props.delBut(true);
              props.cohortListState(true);
              props.addNewState(false);
              props.addNewUpdate();
              // clearSelection();
              props.refreshedCohorts();
            }}
          />
        </Dialog>
      )}
      <TableContainer
        component={Paper}
        style={{
          overflowX: "auto",
          width: "100%",
          backgroundColor: "var(--color-mk-primary-10) !important",
        }}
        elevation={0}
      >
        <Table sx={{ width: "max-content", tableLayout: "auto" }} size="medium">
          <TableHead>
            <TableRow
              sx={{
                "&:hover": {
                  // backgroundColor: "#F5F6FD!important",
                  backgroundColor: "var(--color-mk-primary-10) !important",
                },
              }}
            >
              <TableCell>
                <Checkbox
                  sx={{
                    transform: "scale(1.3)", // Increase size
                    color: "#6464E5", // Default color
                    "&.Mui-checked": {
                      color: "#FF5733", // Checked color
                    },
                    "& .MuiSvgIcon-root": {
                      fontSize: 28, // Adjust icon size
                    },
                  }}
                  // indeterminate={isIndeterminate}
                  checked={isAllSelected}
                  onChange={handleSelectAll}
                />
              </TableCell>
              <TableCell style={{ width: "13%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.fname"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "3%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.lname"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "3%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.status"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "3%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.language"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "7%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.phNo"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "10%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.email"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "3%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.employee"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "2.5%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.dob"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "2.5%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.dateOfJoin"></FormattedMessage>
              </TableCell>

              <TableCell style={{ width: "2.5%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.lastWorkingDate"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "3%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.gender"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "13%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.department"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "13%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.desg"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "10.5%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.location"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "11%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.branch"></FormattedMessage>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              paginatedData.length>0?
            (paginatedData?.map(
              (
                user: {
                  userId: any;
                  userProfile: {
                    firstName:
                      | string
                      | number
                      | boolean
                      | ReactElement<any, string | JSXElementConstructor<any>>
                      | Iterable<ReactNode>
                      | ReactPortal
                      | null
                      | undefined;
                    lastName:
                      | string
                      | number
                      | boolean
                      | ReactElement<any, string | JSXElementConstructor<any>>
                      | Iterable<ReactNode>
                      | ReactPortal
                      | null
                      | undefined;
                    dob: string | number | Date;
                    gender: any;
                  };
                  status:
                    | string
                    | number
                    | boolean
                    | ReactElement<any, string | JSXElementConstructor<any>>
                    | Iterable<ReactNode>
                    | ReactPortal
                    | null
                    | undefined;
                  prefrdLanguage:
                    | string
                    | number
                    | boolean
                    | ReactElement<any, string | JSXElementConstructor<any>>
                    | Iterable<ReactNode>
                    | ReactPortal
                    | null
                    | undefined;
                  empId: any;
                  dateOfJoin: string | number | Date;
                  lastWorkingDate: string | number | Date;
                  department: any;
                  designation: any;
                  location: any;
                  branchName: any;
                  phNo: string;
                  email: string;
                },
                index: any
              ) => {
                // const isSelected = selectedUsers.includes(user.userId);
                const isSelected = !!selectedUsers[user.userId];

                return (
                  <TableRow
                    // sx={{
                    //   backgroundColor: "var(--color-mk-primary-10) !important",
                    //   cursor: "pointer",
                    //   "&:hover": {
                    //     backgroundColor: "var(--color-mk-primary-20) !important",
                    //   },
                    // }}

                    sx={{
                      backgroundColor: isSelected
                        ? "var(--color-mk-primary-50)"
                        : "transparent", // Light orange when selected
                      "&:hover": {
                        backgroundColor: isSelected
                          ? "var(--color-mk-primary-50) !important"
                          : "transparent",
                      },
                    }}
                    key={user.userId || index}
                    // onClick={() => handleGridItemClick(user)} // Pass the row data if needed
                  >
                    <TableCell>
                      <Checkbox
                        sx={{
                          verticalAlign: "middle",
                          transform: "scale(1.3)", // Increase size
                          color: "#6464E5", // Default color
                          "&.Mui-checked": {
                            color: "#FF5733", // Checked color
                          },
                          "& .MuiSvgIcon-root": {
                            fontSize: 28, // Adjust icon size
                          },
                        }}
                        // checked={selectedUsers.includes(user.userId)}
                        checked={!!selectedUsers[user.userId]}
                        onChange={() => handleSelectUser(user.userId)}
                      ></Checkbox>
                    </TableCell>
                    <TableCell>{user?.userProfile?.firstName}</TableCell>
                    <TableCell>{user?.userProfile?.lastName}</TableCell>
                    <TableCell>{toTitleCase(user?.status)}</TableCell>
                    <TableCell>{user?.prefrdLanguage}</TableCell>
                    <TableCell>{user?.phNo}</TableCell>
                    <TableCell>{user?.email}</TableCell>
                    <TableCell>{user?.empId || ""}</TableCell>
                    <TableCell>
                      {user?.userProfile?.dob
                        ? new Date(user.userProfile.dob).toLocaleDateString()
                        : ""}
                    </TableCell>
                    <TableCell>
                      {user?.dateOfJoin
                        ? new Date(user.dateOfJoin).toLocaleDateString()
                        : ""}
                    </TableCell>
                    <TableCell>
                      {user?.lastWorkingDate
                        ? new Date(user?.lastWorkingDate).toLocaleDateString()
                        : ""}
                    </TableCell>

                    <TableCell>
                      {user?.userProfile?.gender
                        ? user?.userProfile?.gender.charAt(0).toUpperCase() +
                          user?.userProfile?.gender.slice(1).toLowerCase()
                        : ""}
                    </TableCell>
                    <TableCell>{user?.department || ""}</TableCell>
                    <TableCell>{user?.designation || ""}</TableCell>
                    <TableCell>{user?.location || ""}</TableCell>
                    <TableCell>{user?.branchName || ""}</TableCell>
                  </TableRow>
                );
              }
            )):
            (
              <TableRow>
                <TableCell colSpan={15} align="center">
                  <div className="w-full h-full flex items-center justify-center text-center text-lg text-mk-primary-bright font-semibold mt-4">
                    <FormattedMessage id="users.addNewUser.noUser" />
                  </div>
                </TableCell>
              </TableRow>
            )
            }
          </TableBody>
        </Table>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{
            // backgroundColor: "#F5F6FD",
            backgroundColor: "var(--color-mk-primary-10) !important",
            padding: 0, // Removes padding
          }}
        >
          <Box display="flex" justifyContent="center" alignItems="center">
            <ThemeProvider theme={theme}>
              <Pagination
                count={totalPages}
                page={page + 1}
                onChange={handleChangePage}
                variant="text" //Removes border and background color
                shape="rounded"
                showFirstButton
                showLastButton
                siblingCount={1}
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    disabled={
                      (item.type === "next" &&
                        !props?.hasMoreDataReference?.current &&
                        page === totalPages - 1) ||
                      ((item.type === "previous" || item.type === "first") &&
                        page === 0) ||
                      (item.type === "last" &&
                        !props.hasMoreDataReference.current &&
                        page === totalPages - 1)
                    }
                  />
                )}
              />
            </ThemeProvider>

            <TablePagination
              rowsPerPageOptions={[
                5,
                10,
                15,
                25,
                { label: intl.formatMessage({ id: "allValue" }), value: -1 },
              ]}
              component="div"
              count={props.totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={handleRowsPerPageChange}
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} 
       
              ${intl.formatMessage({ id: "ofValue" })}
               ${count}
               ${intl.formatMessage({ id: "items" })}
                `
              }
              ActionsComponent={() => null} // to remove navigation buttons
              sx={{
                color: "#6464E5",
              }}
            />
          </Box>
        </Stack>
      </TableContainer>
      <div className="flex justify-end items-end space-x-4">
        <Button
          //   type="back"
          variant="contained"
          disableRipple
          sx={{
            mt: 2,
            borderRadius: "8px",
            textTransform: "capitalize",
            color: "white",

            backgroundColor: "#6464E5",
            "&:hover": {
              backgroundColor: "#E1E2E9",
              color: "black",
            },
            display: "inline-block",
          }}
          //   className="rounded-lg bg-mk-light-grey text-black hover:bg-mk-light-grey hover:text-black focus:outline-none px-4 py-2 mt-10"
          onClick={() => {
            props.delBut(true);
            props.cohortListState(true);
            props.addNewState(false);
            props.addNewUpdate();
            // clearSelection();
            props.refreshedCohorts();
          }}
        >
          <FormattedMessage id="backButton"></FormattedMessage>
        </Button>
        <Button
          type="submit"
          variant="contained"
          disableRipple
          sx={{
            mt: 2,
            borderRadius: "8px",
            textTransform: "capitalize",
            color: "white",

            backgroundColor: "#6464E5",
            "&:hover": {
              backgroundColor: "#E1E2E9",
              color: "black",
            },
            display: "inline-block",
          }}
          // className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey hover:text-black focus:outline-none px-4 py-2 mt-10"
          // onClick={addSelected}
          onClick={(e) => {
            e.preventDefault(); // Prevent form submission if inside a <form>
            e.stopPropagation(); // Prevent event bubbling issues
            addSelected();
          }}
          disabled={
            Object.keys(selectedUsers).length === 0 ||
            Object.values(selectedUsers).every((value) => !value)
          }
        >
          <FormattedMessage id="user.searchCriteria.addSelectedToCohort"></FormattedMessage>
        </Button>
        <Button
          type="submit"
          variant="contained"
          disableRipple
          sx={{
            mt: 2,
            borderRadius: "8px",
            textTransform: "capitalize",
            color: "white",

            backgroundColor: "#6464E5",
            "&:hover": {
              backgroundColor: "#E1E2E9",
              color: "black",
            },
            display: "inline-block",
          }}
          onClick={(e) => {
            e.preventDefault(); // Prevent form submission if inside a <form>
            e.stopPropagation(); // Prevent event bubbling issues
            addEverything();
          }}
          disabled={!props.search}
        >
          <FormattedMessage id="user.searchCriteria.addEverythingToCohort"></FormattedMessage>
        </Button>
      </div>
    </div>
  );
}
